module.exports = __webpack_public_path__ + "img/7.6cc56cf4.jpg";